import {Utilities} from '@shared/utilities/utilities.model';
import {
	CommonMessageCode, EMPTY_MESSAGE,
	MessageComponentType,
	MessageDetail,
	MessageType
} from '@shared/service/message-manager/message.model';

const CRITERIA = '- ExceptionMessage:';

export class MessageManagerUtilities {

	static getMessage<T>(code: string | T, messages: { [key: string]: string }, message?: string): string {
		let parameters: RegExpMatchArray;

		if (code === CommonMessageCode.EMPTY_MESSAGE) {

			if (message) {
				return message;
			}
		
			return EMPTY_MESSAGE;
		}

		if (message) {

			/*
			 * 	Gestione errore proveniente da Miles usando il criterio
			 *  estrapolare il messaggio interno, evitando il precedente sistema dei parametri
			 */ 
			const startCriteria = message.indexOf(CRITERIA);
			if (startCriteria != -1) {
				parameters = [message.substring(startCriteria + CRITERIA.length, message.length).trim()];
				parameters = [parameters[0].substring(2, message.length -3)];
				// continue;
			} else {
				parameters = message.match(new RegExp(Utilities.patternMessage, 'g'));
				parameters = parameters ? parameters.filter(el => !!el).map(el => el.substr(1)).reverse() : [];
			}
		}
		if (messages[code.toString()]) {
			const text: string = messages[code.toString()];
			if (text) {
				if (text.indexOf(`('%s')`) > -1) {
					const slices: string[] = text.split(`('%s')`);
					return slices.reduce((prev, curr) => {
						const parameter: string = parameters.pop();
						return `${prev}${parameter ? parameter : ''}${curr}`;
					});
				} else {
					return text;
				}
			} else {
				return message;
			}
		} else {
			return messages[CommonMessageCode.GENERIC_ERROR];
		}
	}

	static getMessageDetailsFromResponse(response: any): MessageDetail {
		let code: string = null, type: MessageType = null, message: string = null;
		let status: number;

		if (response._body && typeof response._body === 'string') {
			status = JSON.parse(response._body).status;
			code = JSON.parse(response._body).code;
			message = JSON.parse(response._body).message;

		} else {
			status = response.status;
			code = response.code;
			message = response.message;
		}

		(status && status < 400) ? type = MessageType.TYPE_SUCCESS : type = MessageType.TYPE_ERROR;
		if(code === "AUTHORITY_M0015" && status === 409) { type = MessageType.TYPE_WARNING; } //NE-3158
		if (!code) {
			message = null;
			(type === MessageType.TYPE_SUCCESS) ? code = CommonMessageCode.GENERIC_SUCCESS : code = CommonMessageCode.GENERIC_ERROR;
		}

		return {
			code: code,
			message: message,
			type: type,
			componentType: MessageComponentType.FLASH_MESSAGE
		};
	}
	
	static getMessageDetailsFromResponseMultiCode(response: any, msgCodeSingle: string, msgCodeMultiple?: string): MessageDetail {

		if (!response) return null;
		
		if (response._body && typeof response._body === 'string') {
			response = {
				...response,
				...JSON.parse(response._body)
			}
		}

		const bookingsError = 
			response.message.slice( 
				response.message.indexOf('(')+2, 
				response.message.indexOf(')')-1 
			);

		msgCodeMultiple = msgCodeMultiple ? msgCodeMultiple : msgCodeSingle;
		
		let msg = MessageManagerUtilities.getMessageDetailsFromResponse(response);
		msg.code = bookingsError.split(',').length > 1 ? msgCodeMultiple : msgCodeSingle;
		msg.message =  `('${bookingsError}')`;

		return msg;
	}

	static getCodeDetailsFromResponseMultiCode(response: any): Array<string> {
		try {
			if (!response) return null;
		
		if (response._body && typeof response._body === 'string') {
			response = {
				...response,
				...JSON.parse(response._body)
			}
		}

		const bookingsError = 
			response.message.slice( 
				response.message.indexOf('(')+2, 
				response.message.indexOf(')')-1 
			);

		return bookingsError.split(',');//In teoria dovrebbe ritornare un array di code
		} catch (error) {
			return [];
		}
		
	}
}
